import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import DropdownIcon from "../../DropdownIcon";
import { useContext } from "react";
import { classes } from "../classes";

export default function Group({ context }) {

    const {
        group, setGroup,
        groupsList,
    } = useContext(context);

    return (
        <>
            <Typography style={classes.labelInput}>
                Grupos da Ocorrência:
            </Typography>

            <FormControl variant="outlined" style={classes.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    value={group}
                    onChange={(e) => { setGroup(e.target.value); }}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    {
                        groupsList.map(group => (
                            <MenuItem key={group.id} value={group.nameSecretary}>{group.nameSecretary}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        </>
    )
}